import React, { useState, useRef, useContext } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SectionFrame } from "../kits/DesignKit";
import MonoButton from "../kits/DesignKit/MonoButton";
import { logoPath, logoBackPath } from "../config";
import RoughBorder from "../kits/LayoutKit/RoughBorder";
import { NameContext } from "../context/NameContext";



const overlayVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.3 } },
};



const modalVariants = {
  hidden: { y: 40, opacity: 0, scale: 0.98 },
  visible: { y: 0, opacity: 1, scale: 1, transition: { duration: 0.3, type: "spring" } },
};

const ContactForm = () => {
  const [form, setForm] = useState({
    email: "",
    name: "",
    telefon: "",
    betreff: "",
    message: "",
    datenschutz: false,
  });

  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const res = await fetch("https://www.denisbitter.de/stage01/api/sendContact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!res.ok) {
        throw new Error(`Server returned status ${res.status}`);
      }
      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("Antwort ist kein gültiges JSON!");
      }

      setStatus(data.success ? "success" : "error");
    } catch (err) {
      setStatus("error");
      alert("Fehler: " + err.message);
      console.error("Formular Fehler:", err);
    }
  };

  // Reset-Handler für Overlay
  const handleCloseOverlay = () => {
    setStatus(null);
    setForm({
      email: "",
      name: "",
      telefon: "",
      betreff: "",
      message: "",
      datenschutz: false,
    });
  };

  // Ref für RoughBorder im Success-Overlay
  const successModalRef = useRef();

    const { name } = useContext(NameContext);

  return (
    <>
      <SectionFrame>
        <form className="space-y-6 font-mono text-xs text-gray-900" onSubmit={handleSubmit}>
          <div className="grid  gap-6">
            <input
              type="email"
              name="email"
              placeholder={name ? `Deine Email ${name} ?` : "E-Mail"}
              value={form.email}
              onChange={handleChange}
              className="border border-black shadow-sm text-xs rounded-md px-4 py-3 w-full focus:outline-none focus:ring-gray-700 focus:ring-1"
            />
            <input
              type="text"
              name="name"
              placeholder={name ? name : "Name"}
              value={form.name}
              onChange={handleChange}
              className="border border-black shadow-sm text-xs rounded-md px-4 py-3 w-full focus:outline-none focus:ring-1 focus:ring-gray-700"
            />
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <input
              type="text"
              name="telefon"
              placeholder={name ? `Deine Handynummer ${name}?` : "Name"}
              value={form.telefon}
              onChange={handleChange}
              className="border border-black shadow-sm text-xs rounded-md px-4 py-3 w-full focus:outline-none focus:ring-1 focus:ring-gray-700"
            />
            <input
              type="text"
              name="betreff"
              placeholder={name ? `Dein Betreff ${name}?` : "Name"}
              value={form.betreff}
              onChange={handleChange}
              className="border border-black shadow-sm text-xs rounded-md px-4 py-3 w-full focus:outline-none focus:ring-1 focus:ring-gray-700"
            />
          </div>
          <textarea
            name="message"
            placeholder={name ? `Was magst du mir sagen ${name}?` : "Name"}
            rows="5"
            value={form.message}
            onChange={handleChange}
            className="border border-black shadow-sm text-xs rounded-md px-4 py-3 w-full focus:outline-none focus:ring-1 focus:ring-gray-700"
          ></textarea>
          <div className="flex items-start space-x-2">
            <input
              type="checkbox"
              name="datenschutz"
              checked={form.datenschutz}
              onChange={handleChange}
              className="mt-1 border border-black rounded"
            />
            <label className="text-xs text-gray-700 px-2 py-1">
              Ich stimme der Datenverarbeitung gemäß{" "}
              <a href="/datenschutz" className="underline hover:text-brand hover:bg-gray-950 hover:pl-1 hover:pr-1">Datenschutz</a> zu.
            </label>
          </div>
          <MonoButton type="submit" className="w-full">
            <span className="text-xs">Nachricht senden</span>
          </MonoButton>
          {status === "error" && (
            <p className="text-red-600">Fehler beim Versand. Bitte erneut versuchen.</p>
          )}
        </form>
      </SectionFrame>

      {/* Overlay bei Erfolg */}
      <AnimatePresence>
        {status === "success" && (
          <motion.div
            className="fixed inset-0 bg-white/25 backdrop-blur-lg z-50 flex items-center justify-center"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={overlayVariants}
            onClick={handleCloseOverlay} // Klick außerhalb schließt Overlay
          >
            <motion.div
              ref={successModalRef}
              className="px-8 py-12 max-w-md w-full flex flex-col items-center gap-4 bg-white shadow-xl relative cursor-pointer"
              initial="hidden"
              animate="visible"
              exit="hidden"
              variants={modalVariants}
              onClick={e => e.stopPropagation()} // Klick im Modal schließt NICHT
            >
              <div className="w-14 h-14  mx-auto rounded-full shadow-lg bg-white border flex items-center justify-center ring-1 ring-gray-200">
                <img
                  src={logoBackPath}
                  alt="Logo"
                  className="w-12 h-12 object-contain border rounded-full"
                  loading="lazy"
                />
              </div>
              <div className="text-sm font-mono font-semibold text-gray-900 mb-2">
                Danke für deine Nachricht!
              </div>
              <div className="text-xs text-gray-600 mb-4 text-center">
                Ich werde mich innerhalb eines Tages bei dir melden.<br />  
              
          <p className="text-xs">Oder schneller, wenn Du mich anrufst: <br />
            <a href="tel:+4915153231791" className="text-brand hover:underline">0151 5323 1791</a> <br />
            <p className="text-xs"> Danke, bis später, Denis</p>
           </p>
              </div>
              {/* RoughBorder GANZ AUSSEN */}
              <RoughBorder
                parentRef={successModalRef}
                radius={10}
                padding={2}
               color="#AC8E66" 
                strokeWidth={0.3}
                roughness={1}
                bowing={2}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ContactForm;
